
<div class="empty-list {{ size }}" *ngIf="isEmpty && !loading">
	<mat-icon svgIcon="empty_list"></mat-icon>
	<p class="main-emp">{{ 'general.empty_list' | translate }}</p>
	<!-- <p class="desc-emp">{{ 'general.empty_list_desc' | translate }}</p> -->
</div>
